<template>
  <div>
    <v-container fluid>
      <SlaTimeout />
      <v-divider class="my-4" />
      <CloseByBot />
      <v-divider class="my-4" />
      <TicketAssignment />
      <template v-if="!isCIMB">
        <v-divider class="my-4" />
        <TicketType />
      </template>
      <v-divider class="my-4" />
      <AdminAutoCloseTicket />
      <template v-if="isCustomerSupportService && selectedBot.unlock_survey">
        <v-divider class="my-4" />
        <SurveySetting />
      </template>
    </v-container>
  </div>
</template>

<script>
import SlaTimeout from './SlaTimeout.vue'
import CloseByBot from './CloseByBot.vue'
import TicketAssignment from './TicketAssignment.vue'
import TicketType from './TicketType.vue'
import SurveySetting from './CustomerSupportService/SurveySetting.vue'
import AdminAutoCloseTicket from './AdminAutoCloseTicket.vue'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'

export default {
  name: 'SettingView',
  components: {
    SlaTimeout,
    CloseByBot,
    TicketAssignment,
    TicketType,
    SurveySetting,
    AdminAutoCloseTicket
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCustomerSupportService']),
    isCIMB() {
      return PAGE.CIMB.includes(this.selectedBot.pageid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/index.vue